/*eslint-disable*/
export default registry => {
  let $quantity = $(registry).find('#quantity')
  $(registry).find('.quantity-control').click((event) => {
    if (event.currentTarget.id === 'minus-quantity' && $quantity.val() > 1) {
      $quantity.val(parseInt($quantity.val()) - 1)
    }
    if (event.currentTarget.id === 'plus-quantity') {
      $quantity.val(parseInt($quantity.val()) + 1)
    }
    $(registry).find('#quantity-amount p').text(`${$quantity.val()}`)
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/registry-quantity.js